export default __webpack_public_path__ + "static/media/plndrm.e86234bf.png";